var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 42,
    viewBox: "0 0 60 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 42C6.04688 42 0 35.9531 0 28.5C0 22.6125 3.76875 17.6063 9.01875 15.7594C9.00938 15.5063 9 15.2531 9 15C9 6.7125 15.7125 0 24 0C29.5594 0 34.4063 3.01875 37.0031 7.51875C38.4281 6.5625 40.1531 6 42 6C46.9688 6 51 10.0312 51 15C51 16.1437 50.7844 17.2313 50.4 18.2438C55.875 19.35 60 24.1969 60 30C60 36.6281 54.6281 42 48 42H13.5ZM20.9063 21.6562C20.025 22.5375 20.025 23.9625 20.9063 24.8344C21.7875 25.7062 23.2125 25.7156 24.0844 24.8344L27.7406 21.1781L27.75 33.75C27.75 34.9969 28.7531 36 30 36C31.2469 36 32.25 34.9969 32.25 33.75V21.1781L35.9063 24.8344C36.7875 25.7156 38.2125 25.7156 39.0844 24.8344C39.9563 23.9531 39.9656 22.5281 39.0844 21.6562L31.5844 14.1562C30.7031 13.275 29.2781 13.275 28.4063 14.1562L20.9063 21.6562Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProductIcon);
export default __webpack_public_path__ + "static/media/add_product_icon.7ebdd320cc7a67650c70246218d47563.svg";
export { ForwardRef as ReactComponent };